<template>

    <div class="web_title">
      <div class="web_title_content">
        <img class="title_img" src="../../assets/png/nav_logo_title.png" style="height:39px;width: auto" >
        <div class="title_content">

          <div class="title">
            <router-link :to="{path: '/contact'}">
              <span style="cursor:pointer;">联系我们</span>
            </router-link>
          </div>
          <div class="title">
            <router-link :to="{path: '/join'}">
              <span style="cursor:pointer;">加入我们</span>
            </router-link>
          </div>

          <div class="title">
            <router-link :to="{path: '/cooperate'}">
              <span style="cursor:pointer;">商务合作</span>
            </router-link>
          </div>

          <div class="title">
            <router-link :to="{path: '/area'}">
              <span style="cursor:pointer;">关于我们</span>
            </router-link>
          </div>

          <div  :class="isProduct?'title title_red':'title'">
            <router-link :to="{path: '/index'}">
              <span style="cursor:pointer;">首页</span>
            </router-link>
          </div>

        </div>
      </div>
    </div>




</template>

<script>
  import router from '../../router'

export default {
  name: 'Header',
  data () {
    return {
        isProduct:false
    }
  },
  methods: {

  },
  mounted :function() {
      if(location.hash.indexOf('/product')!=-1){
        this.isProduct=true
      }
//      alert(this.isProduct)
//    alert(location.hash.indexOf('/product')!=-1)
  },
    updated(){

    }
}
</script>


<style scoped="page">

  .web_title{
    width: 100%;
    height: 80px;
    background-color: #ffffff;
    position: fixed;
    top: 0;
    z-index: 1000;
  }
  .web_title_content{
    width: 1290px;
    height: 80px;
    margin: auto;
    position: relative;

  }
  .web_title_content a{text-decoration: none;color: #000000;}
  .title_img{
    margin-left: 40px;
    margin-top: 18px;
  }
  .title_content{
    height: 80px;
    position: absolute;
    right:45px;
    top: 0;
  }
  .title{
    float: right;
    height: 80px;
    line-height: 80px;
    font-size: 18px;
    margin-right: 50px;
  }
  .title_red{
    float: right;
    height: 70px;
    line-height: 80px;
    font-size: 18px;
    border-bottom: 2px solid #cd001b;
    color: #000000;
  }
  .title:first-child{margin-right: 0}

  .router-link-active {
    float: right;
    height: 70px;
    line-height: 80px;
    font-size: 18px;
    border-bottom: 2px solid #cd001b;
    color: #000000;
  }



</style>



// WEBPACK FOOTER //
// src/components/web/BaseHeader.vue